module.exports = __webpack_public_path__ + "static/media/Sport_main_t.84bbe556.jpg";